var React = require('react');

function Wish (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 13L6.2825 12.3438C4.38083 10.5821 2.85833 9.04502 1.710D47A15 7.73261C0.571667 6.42019 0 5.09004 0 3.74216C0 2.67804 0.352917 1.78831 1.05875 1.07299C1.76458 0.357662 2.63667 0 3.675 0C4.27 0 4.85917 0.144839 5.4425 0.434516C6.02583 0.724193 6.545 1.20009 7 1.86221C7.51333 1.20009 8.04417 0.724193 8.5925 0.434516C9.14083 0.144839 9.71833 0 10.325 0C11.3633 0 12.2354 0.357662 12.9412 1.07299C13.6471 1.78831 14 2.67804 14 3.74216C14 5.09004 13.4283 6.42019 12.285 7.73261C11.1417 9.04502 9.61917 10.5821 7.7175 12.3438L7 13Z","fill":"currentColor"}));
}

Wish.defaultProps = {"width":"21","height":"18","viewBox":"0 0 14 13","fill":"none"};

module.exports = Wish;

Wish.default = Wish;
